<template>
  <v-container class="pa-0 ma-0" fluid>
    <v-card elevation="0" min-width="100%">
      <common-data-table
        :headers="headers"
        collectionName="contractors"
        @click:row="rowClicked"
      >
        <template v-slot:newItemPopup="{ close, item, formKey }">
          <common-editing-popup
            ref="editPopup"
            title="New contractor"
            saveBtnTitle="Save contractor"
            @close="close()"
            :canSubmit="formValid"
            collectionName="contractors"
            :originalItem="item"
            :loading="addingContractor"
            :key="'contractor-edit-' + (item ? item.id : formKey)"
            @created:item="rowClicked"
            @submit="submit"
          >
            <template v-slot:default="{ editedItem, extraData }">
              <new-contractor
                @formStateChange="formStateChange"
                :editedItem="editedItem"
                :extraData="extraData"
              ></new-contractor>
            </template>
          </common-editing-popup>
        </template>
      </common-data-table>
    </v-card>
  </v-container>
</template>

<script>
import CommonDataTable from '@/components/CommonDataTable.vue'
import CommonEditingPopup from '@/components/CommonEditingPopup.vue'
import NewContractor from '@/views/people/NewContractor.vue'
import { mapGetters, mapActions } from 'vuex'
import { v4 as uuidv4 } from 'uuid'
import { storage } from '@/firebaseConfig'

export default {
  name: 'Contractors',
  components: {
    CommonDataTable,
    CommonEditingPopup,
    NewContractor,
  },
  data() {
    return {
      formValid: false,
      addingContractor: false,
      headers: [
        {
          text: 'Company name',
          value: 'companyName',
        },
        {
          text: 'Email',
          value: 'email',
        },
        {
          text: 'Phone number',
          value: 'phoneNumber',
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['companyId']),
  },
  methods: {
    ...mapActions(['showError']),
    formStateChange(newValue) {
      this.formValid = newValue
    },
    rowClicked(data) {
      this.$router.push({
        name: 'contractor-details',
        params: { id: data.id, title: data.companyName },
      })
    },

    async uploadNewImages(item, extraData) {
      const file = extraData?.imagePreview?.file
      if (file) {
        const fileName = uuidv4()
        const imageRef = storage
          .ref()
          .child(`companies/${this.companyId}/contractors/${fileName}`)
        const snapshot = await imageRef.put(file)
        const fileURL = await snapshot.ref.getDownloadURL()
        item.logoURL = fileURL
      }
    },
    async submit(item, extraData) {
      try {
        this.addingContractor = true
        await this.uploadNewImages(item, extraData)
        this.$refs.editPopup.submitDefault()
      } catch (error) {
        console.error(error)
        this.showError(error)
      } finally {
        this.addingContractor = false
      }
    },
  },
}
</script>
